import * as React from 'react'
import { theme } from '../theme'

interface Props {
    onClick: () => void
    className?: string
    style?: React.CSSProperties
}

export const CreateWithAiThumbnail = ({
    onClick,
    className,
    style,
}: Props): JSX.Element => {
    const [isHovered, setIsHovered] = React.useState(false)

    return (
        <div
            onClick={onClick}
            className={className}
            style={{
                ...style,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: isHovered ? theme.colors.background : theme.colors.surface,
                border: `1px dashed ${isHovered ? theme.colors.primary : theme.colors.border}`,
                borderRadius: theme.borderRadius.sm,
                cursor: 'pointer',
                transition: 'all 0.2s ease-out',
                overflow: 'hidden',
                flexShrink: 0,
                position: 'relative',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <img
                src="/images/create_with_ai_placeholder_1.jpeg"
                alt="Create New With AI"
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    padding: 0,
                    boxSizing: 'border-box',
                    opacity: isHovered ? 0.8 : 1,
                }}
            />
        </div>
    )
}
